<template>
  <div v-if="h5ConfigDetails" class="head-part">
    <img class="bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['headImg']['headBg'][0]}`" alt="">
    <div class="img-btn">
      <img @click="_show_myprize()" class="my-prize-icon" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['myPrize'][0]}`" alt="">
      <img @click="showOperate()" class="activity-rule" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['rules'][0]}`" alt="">
    </div>

    <!-- loading -->
    <loading-show ref="loadingShow"></loading-show>
    <!-- 我的奖品 -->
    <my-prize ref="myPrize"></my-prize>
    <!-- Q币兑换弹窗 -->
    <exchange-code ref="exchangeCode"></exchange-code>
    <!-- Q币兑换信息弹窗 -->
    <cDK-info ref="CDKInfo"></cDK-info>
    <!-- livelink入口 -->
    <bind-banner v-if="this.llkSwitchOn" :login="_login"></bind-banner>
  </div>
</template>

<script>
// @ is an alias to /src
import store from '@/store/index'
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import { $copyCode } from '@/util/util'
import { global } from '@/config/global'
import { getCouponsByUserId, getCDKHisByUserId } from '@/service/apis'
import LoadingShow from '@/components/modal/LoadingShow'
import MyPrize from '@/components/modal/MyPrize'
import ExchangeCode from '@/components/modal/ExchangeCode'
import CDKInfo from '@/components/modal/CDKInfo'
import BindBanner from '@/components/liveLink/BindBanner'
// import { getCDKHisByUserId } from '@/service/apis'

export default {
  name: 'HeadDiagram',
  data () {
    return {
      baseUrl,
      hisPrizePool: [],
      hisCDKPool: ''
    }
  },
  props: ['showOperate'],
  components: {
    LoadingShow, MyPrize, ExchangeCode, CDKInfo, BindBanner
  },
  computed: {
    ...mapState(['userInfo', 'h5ConfigDetails', 'h5ConfigImgPath', 'isLogin', 'couponList', 'couponsHistory', 'activityConfig', 'llkSwitchOn'])
  },
  created () {
  },
  mounted () {
  },
  methods: {
    _copy () {
      $copyCode(JSON.stringify(this.userInfo))
    },
    _login () {
      this.$emit('login', true)
    },
    // 我的奖品
    async _show_myprize () {
      this.$sensors.track('app_page_click', {button_name: 'welfare'})

      if (!this.isLogin) {
        return this.$emit('login')
      }
      if (!this.activityConfig.activityCoupons.length) {
        this.$parent.$refs.errorWin.show(global.ERROR_CODE_CONFIG_ERROR)
        return
      }
      
      this.$refs.loadingShow.show()
      try {
        let ch = await getCouponsByUserId(this.userInfo.userId)
        store.commit('SET_COUPONS_HISTORY', ch)
      } catch (error) {
        this.$refs.loadingShow.close()
        this.$parent.$refs.errorWin.show(global.ERROR_CODE_UNDEFINED)
      }

      // 筛选出本次活动子礼包，去重
      let subCoupons = []
      for (let i = 0; i < this.activityConfig.activityCoupons.length; i++) {
        let value = Object.keys(this.activityConfig.activityCoupons[i].couponClientParas)
        if (value.length) {
          subCoupons = [...subCoupons, ...value]
        }
      }
      let receiveCoupon = this.h5ConfigDetails[0]['couponReceive']['coupon-id'].filter(function(item) {
        return item != ''
      })
      subCoupons = [...subCoupons, ...receiveCoupon]
      subCoupons = [...new Set(subCoupons)]
      // 根据子礼包id筛选用户礼包历史
      let _this = this
      this.hisPrizePoolTemp = !!this.couponsHistory.exchangeHistoryList && this.couponsHistory.exchangeHistoryList.filter(function(item) {
        return subCoupons.indexOf(item.couponId) !== -1 && !(item.couponStatus === 0 || item.couponStatus === 3) && (_this.activityConfig.startTime < Number(item.timestamp)) && (_this.activityConfig.endTime > Number(item.timestamp))
      });
      // 匹配Q币礼包状态
      this.hisCDKPool = await getCDKHisByUserId(this.userInfo.userId)
      this.hisPrizePoolTemp.forEach(item => {
        if (item.gameName && item.gameName.indexOf('Q币') !== -1) {
          item.cdkStatus = 0
          item.cdkStatusTxt = 0 // 未兑换
          item.cdkBtnTxt = '点击申请'
          let record = this.hisCDKPool.find(cdk => {
            return item.couponContent === cdk.cdk
          })
          if (!record) {
            item.prizeImg = this.baseUrl.portalImg + this.h5ConfigImgPath + '/' + this.h5ConfigDetails[0]['drawLotteryImg']['prizesImg'][item.gameIconUrl]
            this.hisPrizePool.push(item)
            return
          }

          item.cdkStatus = record.status
          let cdkStatusTempTxt = ''
          let cdkBtnTempTxt = '点击申请'
          switch (item.cdkStatus) {
            case 0:
              cdkStatusTempTxt = 0 //'未兑换'
              break
            case 1:
              cdkStatusTempTxt = 1 //'兑换中'
              cdkBtnTempTxt = '点击查看'
              break
            case 2:
              cdkStatusTempTxt = 2 //'兑换成功'
              cdkBtnTempTxt = '点击查看'
              break
            default:
              cdkStatusTempTxt = 3 //'兑换失败'
              break
          }
          item.cdkBtnTxt = cdkBtnTempTxt
          item.cdkStatusTxt = cdkStatusTempTxt
          item.qqNum = record.qqNum
          item.prizeImg = this.baseUrl.portalImg + this.h5ConfigImgPath + '/' + this.h5ConfigDetails[0]['drawLotteryImg']['prizesImg'][item.gameIconUrl]
          this.hisPrizePool.push(item)
        } else if (item.gameName && item.gameName.indexOf('礼包领取') !== -1) {
          let temp = null
          if (item.couponContent.indexOf(';') !== -1) {
            let codes = item.couponContent.split(';')
            let names = item.couponDescription.split(';')
            let imges = item.gameIconUrl.split(';')
            for (let j = 0; j < codes.length; j++) {
              temp = Object.assign({}, item)
              temp.couponContent = codes[j]
              temp.couponDescription = names[j]
              temp.gameIconUrl = imges[j]
              temp.prizeImg = this.baseUrl.portalImg + this.h5ConfigImgPath + '/' + this.h5ConfigDetails[0]['couponReceivePicture']['prizesImg'][imges[j]]
              this.hisPrizePool.push(temp)
            }
          } else {
            item.prizeImg = this.baseUrl.portalImg + this.h5ConfigImgPath + '/' + this.h5ConfigDetails[0]['couponReceivePicture']['prizesImg'][item.gameIconUrl]
            this.hisPrizePool.push(item)
          }
        } else {
          item.prizeImg = this.baseUrl.portalImg + this.h5ConfigImgPath + '/' + this.h5ConfigDetails[0]['drawLotteryImg']['prizesImg'][item.gameIconUrl]
          this.hisPrizePool.push(item)
        }
      })
      console.log('this.hisPrizePool')
      console.log(this.hisPrizePool)
      this.hisPrizePool.sort(function (a, b) {
        return b.timestamp - a.timestamp
      })
      this.$refs.loadingShow.close()
      this.$refs.myPrize.show(this.hisPrizePool)
      this.hisPrizePool = []
    },
  }
}
</script>

<style scoped lang="less">
  .head-part{
    position: relative;
    font-size: 0;
    .bg{
      width: 100%;
      height: auto;
      display: block;
    }
    .rules-entry {
      border-radius: 0px 1.5rem 1.5rem 0px;
      position: absolute;
      top: 1rem;
      left: 0;
      background: rgba(24, 15, 62, 0.6);
      color:fff;
      font-size: 1.1rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      padding: 0.6rem 0.9rem 0.6rem 0.6rem;
    }

    .img-btn {
      width: 2.53rem;
      height: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      font-size: 1.1rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      display: flex;
      flex-direction: column;
      align-items: self-end;
      justify-content: center;

      .my-prize-icon {
        width: auto;
        height: 5.9rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin-bottom: 1.3rem;
      }
      .activity-rule {
        width: auto;
        height: 5.9rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }
  }
</style>